export default {
  buttons: {
    login: 'Zaloguj się',
  },
  feedback: {
    incorrect_code: 'Wprowadzony kod jest nieprawidłowy. Spróbuj ponownie.',
    expired_code: 'Ten kod wygasł. Poproś o nowy.',
    too_many_attempts: 'Zbyt wiele prób. Zaczekaj chwilę i spróbuj ponownie.',
    unknown: 'Coś poszło nie tak podczas weryfikacji kodu. Spróbuj ponownie.',
    network_error: 'Nie możemy połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie.',
  },
};
